<template>
  <div class="yCenter">
    <v-btn
      :height="height"
      :width="width"
      outlined
      class="btnClass mx-auto font-weight-bold"
      @click="onClick()"
    >
      <span class="btnText">
        {{ $t(text) }}
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'WhiteButton',
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    textSize: { type: String, required: false, default: '12px' },
    height: { type: String, required: false, default: '' },
    width: { type: String, required: false, default: '100%' }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
.btnClass {
  color: #c8cfd7;
  min-width: 48px !important;
  background-color: #ffffff;
}
.btnText {
  color: #6a6a6a;
}
</style>
